import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar'; 
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { SendArToIntacctComponent} from '../send-ar-to-intacct/send-ar-to-intacct.component'

@NgModule({
  declarations: [SendArToIntacctComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    GridModule, DateInputsModule,
    ProgressBarModule,
  ],
  exports: [SendArToIntacctComponent],
  providers: [],
})
export class SendArToIntacctModule { }